class workSection extends HTMLElement {
  constructor() {
    super();
    let swiperElement = this.querySelector('[data-works-swiper]')
    let swiper = new Swiper(swiperElement, {
      slidesPerView: 1.5,
      slideToClickedSlide: true,
      spaceBetween: 0,
      loop: true,
      speed: 1000,
      autoplay: {
        disableOnInteraction: false,
      },
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          speed: 2500,
          slidesPerView: 3.5,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 0,
        },
      },
    });
  }
}

customElements.define('work-section', workSection);
